<template>
    <div class="main-container">
        <v-progress-circular
            indeterminate
            color="#e79831"
            :width="7"
            :size="70"
        ></v-progress-circular>
    </div>
</template>

<script>
import store from '@/services/business/store';

export default {
    name: 'CheckoutSuccessPage',
    metaInfo: {
		title: 'Checkout Success - LensAdvisors',
		meta: [
			{ vmid: 'description', name: 'description', content: 'Compare prices among the leading contact lens suppliers' }
		]
	},
    data: () => {
        return {}
    },
    created() {
        store.completeCheckoutSession(this.$route.params.id, () => this.$router.push('/business/dashboard'));
    }
};
</script>

<style lang="scss" scoped>
    .main-container {
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>